<div class="settings-container">
    <div></div>
    <mat-button-toggle-group class="review-mode-toggle" [value]="selectedMode" (change)="onReviewModeChange($event.value)" aria-label="Review Mode">
        <mat-button-toggle [value]="ReviewMode.Select">Auswählen</mat-button-toggle>
        <mat-button-toggle [value]="ReviewMode.Order">Ordnen</mat-button-toggle>
    </mat-button-toggle-group>
</div>

<mat-divider></mat-divider>

<mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" cdkDropList (cdkDropListDropped)="drop($event)" cdkDropListData="dataSource">
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> Ordnen </mat-header-cell>
        <mat-cell *matCellDef="let review; let i = index">
            <button mat-icon-button (click)="moveUp(i)" [disabled]="i === 0">
                <mat-icon>arrow_upward</mat-icon>
            </button>
            <button mat-icon-button (click)="moveDown(i)" [disabled]="i === dataSource.length - 1">
                <mat-icon>arrow_downward</mat-icon>
            </button>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
        <mat-cell *matCellDef="let review" class="drag-cursor"> {{review.name}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="rating">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Bewertung </mat-header-cell>
        <mat-cell *matCellDef="let review" class="drag-cursor"> 
            @for (star of ratingOptions; let index = $index; track $index) {
                <mat-icon class="{{ index < review.rating ? 'filled-rating-stars' : 'filled-rating-stars' }}">star</mat-icon>
            }
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="text">
        <mat-header-cell *matHeaderCellDef> Text </mat-header-cell>
        <mat-cell *matCellDef="let review" class="drag-cursor"> 
            <div class="cell-content">
                <div #ellipsisRef ellipsis (ellipsis-change)="onTextTruncated($event, review)" [ngClass]="{ 'line-clamp': !review.expanded }" [ellipsis-content]="review.text"></div>
                @if(review.isTruncated && !review.expanded){
                    <span class="show-more-button" (click)="toggleShowMore(review)">Mehr anzeigen</span>
                } @else if(review.expanded) {
                    <span class="show-more-button" (click)="toggleShowMore(review)">Weniger anzeigen</span>
                }
            </div>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></mat-row>
</mat-table>

